import React, { useEffect, useState } from 'react';
import { Column } from '@codeparva/ui-components-library';
import { ContactUsPageTypes } from '..';
import { ContactUsOfficeAndGateHours } from './ContactUsOfficeAndGateHours';
import { ContactUsSocialMediaIcons } from './ContactUsSocialMediaIcons';
import { ReachUs } from './ContactReachUs';
import { ClickableTextTypes } from '../../../components/clickableText/ClickableTextTypes';
const detailsLinkColor = (inVariant: string) =>
  inVariant !== 'newContactUsLightTheme' ? 'normal' : 'highlighted';
const detailsTitleColor = (inVariant: string) =>
  inVariant !== 'newContactUsLightTheme' ? 'has-text-secondary' : '';

export const StandardContactDetails = ({
  variant,
  contactDetails,
}: ContactUsPageTypes.IContactUsPage) => {
  const curLocation = contactDetails.facilityGateHours?.locationConfig
    .locations[0]!;

  const getAddressDetails = () => {
    if (curLocation && curLocation.gMapDetails) {
      return {
        googleMapPlaceId: curLocation.googleMapPlaceId,
        gMapDetails: curLocation.gMapDetails,
      };
    }
    return undefined;
  };

  const initialAddressConfig: ClickableTextTypes.IClickableText = {
    text: curLocation.addressText,
    type: 'address',
    addressDetails: getAddressDetails(),
  };
  const [addressDetails, setAddressDetails] = useState<
    ClickableTextTypes.IClickableText
  >(initialAddressConfig);

  useEffect(() => {
    const newAddressDetails = getAddressDetails();
    setAddressDetails({
      ...initialAddressConfig,
      addressDetails: newAddressDetails,
    });
  }, [curLocation?.gMapDetails]);

  const isEmpty = (obj: any) => {
    return Object.keys(obj).length === 0;
  };

  const {
    facilityAddress = [],
    mailingAddress = [],
    contactNumber = [],
    emailAddress = [],
    facilityGateHours,
    socialIcons = {},
    facilityGateHours: {} = {},
  } = contactDetails;
  const HorizontalSocialMediaIconsSection = () => {
    return (
      <>
        {isEmpty(socialIcons) ? (
          <></>
        ) : (
          <Column className="socialIconsSection is-flex is-align-content-center">
            <ContactUsSocialMediaIcons
              iconsData={socialIcons}
              allIconsColor="primary"
            />
          </Column>
        )}
      </>
    );
  };

  const iconColorHelper =
    variant === 'newContactUsLightTheme' ? 'normal' : 'highlighted';

  const getMailingAddress = () => {
    if (mailingAddress[0].data) {
      return mailingAddress;
    }
    mailingAddress[0].data = facilityAddress[0].data;
    return mailingAddress;
  };

  return (
    <Column className="detailsContentContainer" paddingless>
      <Column className={`contactList ${detailsLinkColor(variant)}`}>
        {facilityAddress && (
          <ReachUs
            data={facilityAddress}
            allIconsColor={iconColorHelper}
            linkType="address"
            addressDetails={addressDetails.addressDetails}
            title={variant === 'newContactUsDarkTheme' ? 'Location' : ''}
          />
        )}
        {contactNumber && (
          <ReachUs
            data={contactNumber}
            linkType="phone"
            allIconsColor={iconColorHelper}
            title={variant === 'newContactUsDarkTheme' ? 'Phone' : ''}
          />
        )}
        {mailingAddress && (
          <ReachUs
            data={getMailingAddress()}
            allIconsColor={iconColorHelper}
            linkType="address"
            addressDetails={addressDetails.addressDetails}
            title={variant === 'newContactUsDarkTheme' ? 'Mailing Address' : ''}
          />
        )}
        {emailAddress && (
          <ReachUs
            data={emailAddress}
            linkType="email"
            allIconsColor={iconColorHelper}
            title={variant === 'newContactUsDarkTheme' ? 'Email' : ''}
          />
        )}
      </Column>
      {facilityGateHours && (
        <Column className={`hoursSection ${detailsTitleColor(variant)}`}>
          <ContactUsOfficeAndGateHours {...facilityGateHours} />
        </Column>
      )}
      <HorizontalSocialMediaIconsSection />
    </Column>
  );
};

export const SkewContactDetails = (
  detailsInput: ContactUsPageTypes.TContactDetails
) => {
  const curLocation = detailsInput.facilityGateHours?.locationConfig
    .locations[0]!;

  const getAddressDetails = () => {
    if (curLocation && curLocation.gMapDetails) {
      return {
        googleMapPlaceId: curLocation.googleMapPlaceId,
        gMapDetails: curLocation.gMapDetails,
      };
    }
    return undefined;
  };

  const initialAddressConfig: ClickableTextTypes.IClickableText = {
    text: curLocation.addressText,
    type: 'address',
    addressDetails: getAddressDetails(),
  };
  const [addressDetails, setAddressDetails] = useState<
    ClickableTextTypes.IClickableText
  >(initialAddressConfig);

  useEffect(() => {
    const newAddressDetails = getAddressDetails();
    setAddressDetails({
      ...initialAddressConfig,
      addressDetails: newAddressDetails,
    });
  }, [curLocation?.gMapDetails]);

  const { facilityAddress = [] } = detailsInput;
  const { emailAddress = [] } = detailsInput;
  const { contactNumber = [] } = detailsInput;
  const { facilityGateHours } = detailsInput;

  return (
    <Column className="skewDetailsContentContainer">
      <Column className={`contactList ${detailsLinkColor('highlighted')}`}>
        <ReachUs
          data={facilityAddress}
          title="LOCATION"
          linkType="address"
          addressDetails={addressDetails.addressDetails}
        />
        {contactNumber && (
          <ReachUs data={contactNumber} title="PHONE" linkType="phone" />
        )}
        {emailAddress && (
          <ReachUs data={emailAddress} title="EMAIL" linkType="email" />
        )}
      </Column>
      {facilityGateHours && (
        <Column className="hoursSection has-text-secondary">
          <ContactUsOfficeAndGateHours {...facilityGateHours} />
        </Column>
      )}
    </Column>
  );
};
